import { render, staticRenderFns } from "./receipe-row.vue?vue&type=template&id=f378db3c&scoped=true"
import script from "./receipe-row.vue?vue&type=script&lang=js"
export * from "./receipe-row.vue?vue&type=script&lang=js"
import style0 from "./receipe-row.vue?vue&type=style&index=0&id=f378db3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378db3c",
  null
  
)

export default component.exports